import React from 'react';
import ParentLayout from '../Layout';
import useRouter from '../../../hooks/useRouter';
import User from '../../_common_user/ManageUser';
import useQuery from './useQuery';
import StudentsServed from '../../_common_user/User/StudentsServed';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import useDialogLauncher from '../../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';

export default function Layout(props) {
  const { location } = useRouter();
  const launch = useDialogLauncher();

  const PAGE_SIZE = 12;

  const result = useQuery({
    location,
    PAGE_SIZE
  });

  const csvQuery = useQuery({
    location,
    PAGE_SIZE,
    returnRawQuery: true
  });

  function onDownload(query) {
    launch(DialogManager.CSVDownload.Config(query));
  }

  return (
    <ParentLayout
      breadcrumbs={['Explore', 'Partners']}
      title="50+ Students Served"
      description={(
        <span>
          These are partners who have worked with at least 50 students through events or
          projects. CommunityShare recommends considering them for media & social media
          coverage, appreciation, event invitations, presentations, and thank you phone
          calls.
        </span>
      )}
      pageSize={PAGE_SIZE}
      result={result}
      csvQuery={function () {
        onDownload(csvQuery);
      }}
      row={function(user) {
        return (
          <User key={user.id} user={user}>
            <div className="bg-cs-gray-50 p-4 border-t border-cs-gray-100">
              <StudentsServed user={user} />
            </div>
          </User>
        );
      }}
    />
  );
}
